<template>
  <v-card min-height="390px" xs="12" md="4">
    <v-row justify="center">
      <v-col>
        <div>
          <h3>Revisa tus datos</h3>
        </div>

        <p class="blue--text">
          <span class="black--text">Email/Usuario: </span>
          {{ account.email }}
        </p>

        <p class="blue--text">
          <span class="black--text">Nombre: </span>
          {{ nombreCompleto }}
        </p>
        <p class="blue--text">
          <span class="black--text">RFC:</span>
          {{ account.rfc }}
        </p>
        <p class="blue--text">
          <span class="black--text">Razón Social:</span>
          {{ account.razonSocial }}
        </p>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { signupData } from '../store/signupWizardHelpers'

export default {
  name: 'SignupReview',
  computed: {
    ...signupData,
    nombreCompleto() {
      return `${this.account.nombres} ${this.account.paterno} ${this.account.materno}`
    }
  }
}
</script>
